<template>
    <div class="card-main" :style="{ width: cardWidth, height: cardHeight,'min-width':minWidth,'min-height':minHeight,'max-width':maxWidth,'max-height':maxHeight }">
        <div class="card-top">
            <div class="card-title">{{ title }}</div>
            <div class="card-tool">
                <slot name="card-tool"></slot>
            </div>
            <div class="card-more">
                <i class="el-icon-more"></i>
            </div>
        </div>
        <div class="card-box">
            <!-- <slot name="card-box"></slot> -->
            <card-table></card-table>
        </div>
    </div>
</template>

<script>
//import cardTable from './card-table.vue';
export default {
  //components: { cardTable },
  name: 'card-M',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    cardWidth: {
      type: String,
      required: false,
      default: '100%'
    }, 
    cardHeight: {
      type: String,
      required: false,
      default: '40vh'
    },
    minWidth: {
      type: String,
      required: false,
      default: '400px'
      },
      minHeight: {
          type: String,
          required: false,
          default: '700px'
      }
  },
  methods: {}
};
</script>

<style scoped scoped lang="scss">
    .card-main {
        /* ��Ƭ */
        position: relative;
        background: rgb(255, 255, 255);
        /*margin: 20px 0px 0px 20px;*/
        padding: 20px;
        margin-bottom: 20px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
    }

    .card-top {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        .card-title
    {
        position: relative;
        color: rgb(128, 128, 128);
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: -1px;
        text-align: left;
    }

    .card-tool {
        display: flex;
        justify-content: space-around;
        margin-right: 20px;
    }

    }

    .card-box {
        height: 100%;
        position: relative;
        // display: flex;
    }
</style>
